<div class="api-key-manager">
  <nb-card>
    <nb-card-header>
      <h5>API Key Management</h5>
    </nb-card-header>
    <nb-card-body>
      <div *ngIf="loading" class="text-center p-3">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="ms-2">Loading...</span>
      </div>
      
      <div *ngIf="error && !loading" class="alert alert-danger">
        <p>{{ error }}</p>
        <div class="d-flex mt-2">
          <button class="btn btn-sm btn-outline-secondary me-2" (click)="fetchApiKey()">Retry</button>
          <button *ngIf="error.includes('Failed to load API key')" class="btn btn-sm btn-primary" (click)="generateApiKey()">
            <i class="fas fa-key"></i> Generate API Key
          </button>
        </div>
        <!-- Debug information -->
        <div *ngIf="debugInfo" class="mt-3 small">
          <pre class="bg-light p-2" style="max-height: 200px; overflow: auto;">{{ debugInfo }}</pre>
        </div>
      </div>
      
      <div *ngIf="!loading && !error">
        <div *ngIf="apiKey; else noApiKey">
          <div class="key-info">
            <p>
              <strong>Status:</strong> 
              <span class="badge" [ngClass]="apiKey.isActive ? 'bg-success' : 'bg-danger'">
                {{ apiKey.isActive ? 'Active' : 'Inactive' }}
              </span>
            </p>
            <p><strong>Created:</strong> {{ formatDate(apiKey.createdAt) }}</p>
            <p *ngIf="apiKey.lastUsed">
              <strong>Last Used:</strong> {{ formatDate(apiKey.lastUsed) }}
            </p>
            <div class="api-key-value mb-3">
              <strong>API Key:</strong> 
              <div class="d-flex align-items-center mt-1">
                <div class="api-key-text flex-grow-1">
                  <code>{{ showKey ? apiKey.apiKey : '••••••••••••••••••••••••••••••••' }}</code>
                </div>
                <div class="api-key-actions">
                  <button class="btn btn-sm btn-outline-secondary ms-2" (click)="toggleShowKey()">
                    {{ showKey ? 'Hide' : 'Show' }}
                  </button>
                  <button class="btn btn-sm btn-outline-primary ms-2" (click)="copyToClipboard()" [disabled]="!apiKey.isActive">
                    <i class="fas fa-copy"></i> Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div class="key-actions mt-4">
            <button class="btn btn-primary me-3" (click)="generateApiKey()">
              <i class="fas fa-sync-alt"></i> Regenerate API Key
            </button>
            <button *ngIf="apiKey.isActive" class="btn btn-danger" (click)="deactivateApiKey()">
              <i class="fas fa-ban"></i> Deactivate API Key
            </button>
          </div>
          
          <div class="key-security mt-4">
            <div class="alert alert-warning">
              <strong>Security Notice:</strong> Treat API keys as sensitive credentials. When regenerating a key, be sure to update it in your card reader configuration.
            </div>
          </div>
        </div>
        
        <ng-template #noApiKey>
          <div class="text-center p-4">
            <p>No API key found for this store.</p>
            <button class="btn btn-primary" (click)="generateApiKey()">
              <i class="fas fa-key"></i> Generate API Key
            </button>
          </div>
        </ng-template>
      </div>
    </nb-card-body>
  </nb-card>
</div> 